"use client";

import CampusSelectorButton from "@/app/(withHeaderAndFooter)/(sellPages)/courses/course/components/CampusSelectorButton";
import {CampusesById} from "../../../../../types/Campus";
import CampusSelectorDropdown, {
	SetCurrentCampuses,
} from "./CampusSelectorDropdown";
import {
	ButtonProps,
	MenuTrigger,
	Popover,
	Selection,
} from "react-aria-components";
import {useCallback, useState} from "react";

export interface CampusSelectorProps {
	currentCampuses: Set<string>;
	setCurrentCampuses: SetCurrentCampuses;
	allCampusesById: CampusesById;
	// Right now only the onPress prop is used for the button, but this can be expanded in the future
	buttonProps?: Pick<ButtonProps, "onPress">;
}

const CampusSelector: React.FC<CampusSelectorProps> = ({
	currentCampuses,
	setCurrentCampuses,
	allCampusesById,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const onSelectionChange = useCallback(
		(campuses: Selection) => {
			setCurrentCampuses(campuses);
			setIsOpen(false);
		},
		[setCurrentCampuses, setIsOpen]
	);
	return (
		<MenuTrigger>
			<CampusSelectorButton
				currentCampuses={currentCampuses}
				allCampusesById={allCampusesById}
				buttonProps={{onPress: () => setIsOpen(true)}}
			/>
			<Popover isOpen={isOpen} onOpenChange={setIsOpen}>
				<CampusSelectorDropdown
					currentCampuses={currentCampuses}
					setCurrentCampuses={onSelectionChange}
					allCampusesById={allCampusesById}
				/>
			</Popover>
		</MenuTrigger>
	);
};

export default CampusSelector;
